import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

export const Header = styled.h1<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  fontSize: '20px',
  padding: '18px 16px',
  borderBottom: '2px solid #EFEFF0',
  alignItems: 'center',

  [theme.mediaQueries.viewport7]: {
    padding: '20px 24px',
    fontSize: '24px',
    paddingBottom: '20px'
  },

  '& svg': {
    height: '20px',
    width: '20px',
    cursor: 'pointer'
  }
}))

export const OptionHeader = styled.h2<StyledHTMLElement>(({ theme }) => ({
  fontSize: '16px',

  [theme.mediaQueries.viewport7]: {
    fontSize: '16px'
  }
}))

export const OptionsContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px 16px',

  [theme.mediaQueries.viewport7]: {
    padding: '24px 24px'
  }
}))

export const ButtonsContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  gap: '12px',
  flexDirection: 'row-reverse',
  padding: '16px 16px',

  [theme.mediaQueries.viewport7]: {
    padding: '8px 24px 24px',
    flexDirection: 'column'
  }
}))
